/** 超级管理员（roleValue === 1） */
export function isAdmin(userInfo) {
  if (!userInfo) return false;
  return Number(userInfo.roleValue) === 1;
}

/** 是否为普通 user 角色（可查看设备激活等受限菜单） */
export function isUserRole(userInfo) {
  if (!userInfo) return false;
  const roleName = (userInfo.role_name || userInfo.role || "").toString().toLowerCase();
  return roleName === "user";
}

/** 兼容旧「销售相关」权限，映射为运营 / 销售 */
export function expandMarketModules(modules = []) {
  const result = [...modules];
  if (result.includes("销售相关")) {
    if (!result.includes("运营")) result.push("运营");
    if (!result.includes("销售")) result.push("销售");
  }
  return result;
}

/** user 角色默认可访问设备激活 */
export function applyUserRoleModules(modules = [], userInfo) {
  const result = expandMarketModules(modules);
  if (!isUserRole(userInfo)) return result;
  if (!result.includes("设备激活")) result.push("设备激活");
  if (!result.includes("销售")) result.push("销售");
  return result;
}

/** 路由 meta.key 是否在当前用户权限内 */
export function hasRoutePermission(metaKey, userRouters = [], userInfo) {
  if (!metaKey) return true;
  if (userRouters.includes(metaKey)) return true;
  if (
    (metaKey === "运营" || metaKey === "销售" || metaKey === "设备激活") &&
    userRouters.includes("销售相关")
  ) {
    return true;
  }
  if (metaKey === "设备激活" && isUserRole(userInfo)) return true;
  return false;
}

function isMenuItemVisible(item, userRouters, userInfo) {
  if (item.meta && item.meta.hidden) return false;
  if (item.meta && item.meta.adminOnly && !isAdmin(userInfo)) return false;
  if (!item.meta || !item.meta.key) return true;
  return hasRoutePermission(item.meta.key, userRouters, userInfo);
}

/** 菜单项是否存在至少一个可访问的子菜单 */
export function hasVisibleMenuChildren(item, userRouters = [], userInfo) {
  if (!item.children || !item.children.length) return true;
  return item.children.some((child) => {
    if (child.children && child.children.length) {
      return hasVisibleMenuChildren(child, userRouters, userInfo);
    }
    return isMenuItemVisible(child, userRouters, userInfo);
  });
}

/** 按权限过滤侧边栏路由 */
export function filterNavRouters(navRouters, userRouters = [], userInfo) {
  return navRouters
    .filter((item) => userRouters.includes(item.meta.key))
    .filter((item) => hasVisibleMenuChildren(item, userRouters, userInfo));
}
